export default __webpack_public_path__ + "static/media/diagram-1.f289eb91.png";